const styles = {
  wrapper: (theme) => ({
    display: 'flex',
    gap: '24px',
    [theme.breakpoints.down('md')]: { flexDirection: 'column' },
  }),
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: '32px',
    borderRadius: '24px',
    backgroundColor: '#F4F2FA',
  },
  aiSection: (theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    flexShrink: 0,
    gap: '72px',

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  }),
  aiLogosWrapper: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '150px',
    height: '100%',
    [theme.breakpoints.down('sm')]: { width: '100%' },
  }),
  image: {
    width: '100%',
    objectFit: 'contain',
  },
  modelsWrapper: (theme) => ({
    width: '164px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    [theme.breakpoints.down('sm')]: { width: '100%', gap: '8px' },
  }),
  model: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
};

export default styles;
